var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVectorWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39777 0.324754L0.198444 11.5988C0.028271 11.8328 0.00378663 12.1425 0.135076 12.4003C0.266365 12.6582 0.53122 12.8205 0.820545 12.8205H6.20513V19.2307C6.20513 19.5639 6.41963 19.8592 6.73648 19.9622C7.05333 20.0653 7.40049 19.9526 7.59646 19.6832L15.8015 8.40117C15.9717 8.16718 15.9962 7.85749 15.8649 7.59967C15.7336 7.34185 15.4688 7.1795 15.1794 7.1795H9.79486V0.769281C9.79486 0.753991 9.79441 0.738806 9.79353 0.723737M8.43139 0.28079C8.41967 0.295025 8.40846 0.309689 8.39777 0.324754L8.43139 0.28079ZM8.6765 0.0836656C8.58439 0.130476 8.50053 0.196525 8.43139 0.28079L8.6765 0.0836656ZM8.98008 0.00138168C8.87127 0.00773532 8.76853 0.0367067 8.6765 0.0836656L8.98008 0.00138168ZM9.26363 0.0375802C9.1712 0.00749457 9.07496 -0.00429938 8.98008 0.00138168L9.26363 0.0375802ZM9.51412 0.17504C9.44076 0.114668 9.35603 0.067616 9.26363 0.0375802L9.51412 0.17504ZM9.71124 0.420149C9.66443 0.32804 9.59838 0.24418 9.51412 0.17504L9.71124 0.420149ZM9.79353 0.723737C9.78717 0.614922 9.7582 0.512181 9.71124 0.420149L9.79353 0.723737ZM8.2564 3.13479L2.33113 11.282H6.97436C7.39919 11.282 7.74358 11.6264 7.74358 12.0513V16.8652L13.6689 8.71796H9.02563C8.6008 8.71796 8.2564 8.37356 8.2564 7.94873V3.13479Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorWhite);
export default __webpack_public_path__ + "static/media/vector_white.a55d41ae918271a171493e194ad45181.svg";
export { ForwardRef as ReactComponent };